const DAYS_TO_STORE = 365;

export const getTopDomain = (depth: number) => {
  return window.location.host
    .split('.')
    .slice(-depth)
    .join('.');
}

export const setCookie = (
  name: string,
  value: any,
  config?: {
    domain?: string
  }
) => {
  const period = DAYS_TO_STORE * 60 * 60 * 24 * 1000;
  const expiresDate = new Date((period) + +new Date());
  const cookieString = `${name}=${value}; path=/; expires=${expiresDate.toUTCString()}`;
  document.cookie = cookieString;
  document.cookie = `${cookieString}; domain=.${config?.domain || window.location.host}`;
};

export const getCookie = (name: string) => {
  const matches = document.cookie.match(new RegExp(
    `(?:^|; )${name.replace(/([$?*|{}\]\\^])/g, '\\$1')}=([^;]*)`,
  ));
  return matches ? decodeURIComponent(matches[1]) : null;
};const DAYS_TO_STORE = 365;

export const getTopDomain = (depth: number) => {
  return window.location.host
    .split('.')
    .slice(-depth)
    .join('.');
}

export const setCookie = (
  name: string,
  value: any,
  config?: {
    domain?: string
  }
) => {
  const period = DAYS_TO_STORE * 60 * 60 * 24 * 1000;
  const expiresDate = new Date((period) + +new Date());
  const cookieString = `${name}=${value}; path=/; expires=${expiresDate.toUTCString()}`;
  document.cookie = cookieString;
  document.cookie = `${cookieString}; domain=.${config?.domain || window.location.host}`;
};

export const getCookie = (name: string) => {
  const matches = document.cookie.match(new RegExp(
    `(?:^|; )${name.replace(/([$?*|{}\]\\^])/g, '\\$1')}=([^;]*)`,
  ));
  return matches ? decodeURIComponent(matches[1]) : null;
};